import {EventEmitter} from "events";
import Swagger from "swagger-client";
import sessionStore from "./SessionStore";
import RobustWebSocket from "robust-websocket";
import dispatcher from "../dispatcher";

class DataStreamStore extends EventEmitter {
  constructor() {
    super();
    this.getTasksResult = this.getTasksResult.bind(this);
    this.swagger = new Swagger("/swagger/datastream.swagger.json",sessionStore.getClientOpts());
  }

  getTasksResult(filter, onData, onClose, cb) {

    const loc = window.location;
    const wsURL = (() => {
      if (loc.host === "localhost:3000" || loc.host === "localhost:3001") {
        return `ws://localhost:8080/api/datastream/gateways/task-result?id=${filter}`;
      }

      const wsProtocol = loc.protocol === "https:" ? "wss:" : "ws:";
      return `${wsProtocol}//${loc.host}/api/datastream/gateways/task-result?id=${filter}`;
    })();

    const conn = new RobustWebSocket(wsURL,
      ["Bearer", sessionStore.getToken()],
      {
        shouldReconnect: function(event, ws){ return null },
      }
    );

    conn.addEventListener("open", () => {

      this.wsDataStatus = "CONNECTED";
      this.emit("ws.status.change");
    });

    conn.addEventListener("message", (e) => {
      const msg = JSON.parse(e.data);
      if (msg.error !== undefined) {
        dispatcher.dispatch({
          type: "CREATE_NOTIFICATION",
          notification: {
            type: "error",
            message: msg.error.message,
          },
        });
      } else if (msg.result !== undefined) {
        onData(msg.result);
      }
    });

    conn.addEventListener("close", (id) => {
      this.wsDataStatus = null;
      this.emit("ws.status.change");
      onClose(cb, filter);
    });

    conn.addEventListener("error", (err) => {

      this.wsDataStatus = "ERROR";
      this.emit("ws.status.change");
    });

    return conn;
  }

  notify(object) {
    dispatcher.dispatch({
      type: "CREATE_NOTIFICATION",
      notification: {
        type: "success",
        message: `List of ${object} has been exported`,
      },
    });
  }
}

const dataStreamStore = new DataStreamStore();
export default dataStreamStore;
